import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { SuperComponent } from '../../super/super.component';
import { FingerDevicesService } from '../finger-devices.service';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-finger-print-devices',
  templateUrl: './finger-print-devices.component.html',
  styleUrls: ['./finger-print-devices.component.scss']
})
export class FingerPrintDevicesComponent extends SuperComponent implements OnInit {

  branchesdropdown: any[] = [];
  DefaultBranch = 0;
  
  EmpAttendanceTypedropdown: any[] = [];
  EmpAttendanceDeviceCVsdropdown: any[] = [];
  fingerPrintDeviceTypedropdown: any[] = [];
  DeviceAttendanceConfigrationColumnsdropdown: any[] = [];

  EmpAttendanceTypeDefault = 0;
  EmpAttendanceDeviceCVsDefault = 0;
  fingerPrintDeviceTypeDefault = 1;
  DeviceAttendanceConfigrationColumnsDefault = 0;

  // ✅ Form Data matching the exact DTO structure
  formData: any = {
    // From SharePropObject (extends BaseEntityNameDTO)
    nameAr: '',                   
    nameEn: '',                
    description: '',
      UserName: '',               
    password: '', 
    isActive: true,
    dateOfRegistration: new Date(),
    
    // From CreateAttendanceDeviceCommand
    ip: '192.168.50.55',
    serial: '',                  
    model: 'DS-K1T320MFWX',
    attendanceType: 0,           
    port: '80',                  
    CVs: 0,                      
    deviceType: 1,             
    branchId: 0,
    
    // ✅ Nullable fields (optional)
    day: null,
    month: null,
    year: null,
    seconed: null,         
    minute: null,
    hour: null,
    enrollid: null,
    inout: null,
    machinenum: null
  };

  constructor(
    gt: genericCustomStoreService, 
    Objects: ObjectsService,
    translate: TranslateService,
    private _FingerDevicesService: FingerDevicesService
  ) {
    super(Objects, translate, gt);
    
    // Load Branch dropdown
    gt.getdropdowndata('Branch').subscribe({
      next: (res: any[]) => {
        this.branchesdropdown = res || [];
        if (this.branchesdropdown.length > 0 && (this.formData.id === 0||this.formData.id===undefined|| this.formData.id == null)) {
          this.DefaultBranch = this.branchesdropdown[0]?.id ?? 0;
          this.formData.branchId = this.DefaultBranch;
        }
        console.log('📍 Branches loaded:', this.branchesdropdown.length);
      },
      error: (err) => console.error(' Error loading branches:', err)
    });

    // Load Device Attendance Configration Columns dropdown
    _FingerDevicesService.GetDeviceAttendanceConfigrationColumnsdropdown().subscribe({
      next: (res: any[]) => {
        this.DeviceAttendanceConfigrationColumnsdropdown = res || [];
        if (this.DeviceAttendanceConfigrationColumnsdropdown.length > 0) {
          this.DeviceAttendanceConfigrationColumnsDefault = this.DeviceAttendanceConfigrationColumnsdropdown[0]?.code ?? 0;
        }
        console.log('📋 Config Columns loaded:', this.DeviceAttendanceConfigrationColumnsdropdown.length);
      },
      error: (err) => console.error(' Error loading config columns:', err)
    });

    // Load EmpAttendanceType dropdown
    _FingerDevicesService.GetEmpAttendanceTypedropdown().subscribe({
      next: (res: any[]) => {
        this.EmpAttendanceTypedropdown = res || [];
        if (this.EmpAttendanceTypedropdown.length > 0) {
          this.EmpAttendanceTypeDefault = this.EmpAttendanceTypedropdown[0]?.code ?? 0;
          this.formData.attendanceType = this.EmpAttendanceTypeDefault;
        }
        console.log('👤 Attendance Types loaded:', this.EmpAttendanceTypedropdown.length);
      },
      error: (err) => console.error(' Error loading attendance types:', err)
    });

    // Load EmpAttendanceDeviceCVs dropdown
    _FingerDevicesService.GetEmpAttendanceDeviceCVsdropdown().subscribe({
      next: (res: any[]) => {
        this.EmpAttendanceDeviceCVsdropdown = res || [];
        if (this.EmpAttendanceDeviceCVsdropdown.length > 0) {
          this.EmpAttendanceDeviceCVsDefault = this.EmpAttendanceDeviceCVsdropdown[0]?.code ?? 0;
         this.formData.CVs = this.EmpAttendanceDeviceCVsDefault;
        }
        console.log(' CVs Types loaded:', this.EmpAttendanceDeviceCVsdropdown.length);
      },
      error: (err) => console.error(' Error loading CVs types:', err)
    });

    // Load fingerPrintDeviceType dropdown
    _FingerDevicesService.GetfingerPrintDeviceTypedropdown().subscribe({
      next: (res: any[]) => {
        this.fingerPrintDeviceTypedropdown = res || [];
        if (this.fingerPrintDeviceTypedropdown.length > 0) {
          this.fingerPrintDeviceTypeDefault = this.fingerPrintDeviceTypedropdown[0]?.code ?? 1;
          this.formData.deviceType = this.fingerPrintDeviceTypeDefault;
        }
        console.log(' Device Types loaded:', this.fingerPrintDeviceTypedropdown.length);
      },
      error: (err) => console.error(' Error loading device types:', err)
    });
  }

  ngOnInit(): void {
    console.log(' Component initialized');
    console.log(' Initial form data:', this.formData);
  }

  // ✅ Arrow function to preserve 'this' context
  onFormSubmit = (e: any) => {
    console.log(' Submit button clicked!');
    console.log(' Current Form Data:', JSON.stringify(this.formData, null, 2));
    
    // Validate required fields
    const validationErrors: string[] = [];
    
    if (!this.formData.nameAr || this.formData.nameAr.trim() === '') {
      validationErrors.push('الرجاء إدخال اسم الجهاز');
    }
    if (!this.formData.nameEn || this.formData.nameEn.trim() === '') {
      validationErrors.push('الرجاء إدخال اسم الجهاز');
    }
    if (!this.formData.ip || this.formData.ip.trim() === '') {
      validationErrors.push('الرجاء إدخال عنوان IP');
    }
    
    if (!this.formData.branchId || this.formData.branchId === 0) {
      validationErrors.push('الرجاء اختيار الفرع');
    }
    
    if (!this.formData.model || this.formData.model.trim() === '') {
      validationErrors.push('الرجاء إدخال الموديل');
    }
    
    if (!this.formData.port || this.formData.port.trim() === '') {
      validationErrors.push('الرجاء إدخال رقم المنفذ (Port)');
    }

    if (validationErrors.length > 0) {
      notify({
        message: validationErrors.join('\n'),
        type: 'error',
        displayTime: 5000,
        position: { at: 'top center', my: 'top center' }
      });
      console.warn('⚠️ Validation errors:', validationErrors);
      return;
    }

    // ✅ Prepare request data matching EXACT DTO structure
    const requestData = {
      // From SharePropObject -> BaseEntityNameDTO
      nameAr: (this.formData.nameAr || '').trim(),
      nameEn: (this.formData.nameEn || '').trim(),
        UserName: (this.formData.UserName || '').trim(),
      password: (this.formData.password || '').trim(),      
      // From SharePropObject
      description: (this.formData.description || '').trim(),
      isActive: this.formData.isActive ?? true,
      dateOfRegistration: this.formData.dateOfRegistration 
        ? new Date(this.formData.dateOfRegistration).toISOString() 
        : new Date().toISOString(),
      
      // From CreateAttendanceDeviceCommand
      ip: (this.formData.ip || '').trim(),
      serial: (this.formData.serial || '').trim(),    
      model: (this.formData.model || '').trim(),
      attendanceType: Number(this.formData.attendanceType),
      port: (this.formData.port || '80').toString(),      
     CVs: Number(this.formData.CVs||0),                     
      deviceType: Number(this.formData.deviceType),
      branchId: Number(this.formData.branchId),
      
      
      day: this.formData.day !== null && this.formData.day !== undefined ? Number(this.formData.day) : null,
      month: this.formData.month !== null && this.formData.month !== undefined ? Number(this.formData.month) : null,
      year: this.formData.year !== null && this.formData.year !== undefined ? Number(this.formData.year) : null,
      seconed: this.formData.seconed !== null && this.formData.seconed !== undefined ? Number(this.formData.seconed) : null,
      minute: this.formData.minute !== null && this.formData.minute !== undefined ? Number(this.formData.minute) : null,
      hour: this.formData.hour !== null && this.formData.hour !== undefined ? Number(this.formData.hour) : null,
      enrollid: this.formData.enrollid !== null && this.formData.enrollid !== undefined ? Number(this.formData.enrollid) : null,
      inout: this.formData.inout !== null && this.formData.inout !== undefined ? Number(this.formData.inout) : null,
      machinenum: this.formData.machinenum !== null && this.formData.machinenum !== undefined ? Number(this.formData.machinenum) : null
    };

    console.log(' Request Data (JSON):', JSON.stringify(requestData, null, 2));
    console.log(' Data Types Check:', {
      nameAr: typeof requestData.nameAr,
      nameEn: typeof requestData.nameEn,
        UserName: typeof requestData.UserName,
      password: typeof requestData.password,
      port: typeof requestData.port,
      serial: typeof requestData.serial,
      attendanceType: typeof requestData.attendanceType,
      CVs: typeof requestData.CVs,
      deviceType: typeof requestData.deviceType,
      branchId: typeof requestData.branchId
    });

    // Show loading notification
    notify({
      message: 'جاري الحفظ...',
      type: 'info',
      displayTime: 1000,
      position: { at: 'top center', my: 'top center' }
    });

    // Call API
    this._FingerDevicesService.CreateAttendanceDevice(requestData).subscribe({
      next: (response) => {
        console.log('✅ Success Response:', response);
        
        notify({
          message: 'تم حفظ البيانات بنجاح',
          type: 'success',
          displayTime: 3000,
          position: { at: 'top center', my: 'top center' }
        });
        

         this.resetForm();
      },
      error: (error) => {
        console.error(' Full Error Object:', error);
        console.error(' Error Status:', error?.status);
        console.error(' Error Response Body:', error?.error);
        
        let errorMessage = 'حدث خطأ أثناء الحفظ';
        
        // Handle different error response formats
        if (error?.error?.message) {
          errorMessage = error.error.message;
        } else if (error?.error?.errors) {
          // FluentValidation errors format
          const errors = error.error.errors;
          const errorMessages = Object.entries(errors)
            .map(([field, messages]: [string, any]) => {
              if (Array.isArray(messages)) {
                return `${field}: ${messages.join(', ')}`;
              }
              return `${field}: ${messages}`;
            });
          errorMessage = errorMessages.join('\n');
        } else if (error?.error?.title) {
          // ProblemDetails format
          errorMessage = error.error.title;
          if (error.error.errors) {
            const validationErrors = Object.entries(error.error.errors)
              .map(([field, messages]: [string, any]) => `${field}: ${messages}`)
              .join('\n');
            errorMessage += '\n' + validationErrors;
          }
        } else if (error?.message) {
          errorMessage = error.message;
        } else if (error?.statusText) {
          errorMessage = `${error.status}: ${error.statusText}`;
        }
        
        console.error('📝 Formatted Error Message:', errorMessage);
        
        notify({
          message: errorMessage,
          type: 'error',
          displayTime: 6000,
          position: { at: 'top center', my: 'top center' }
        });
      }
    });
  }

  // Reset form method
  resetForm() {
    this.formData = {
      nameAr: '',
      nameEn: '',
       UserName: '',
      password: '',
      description: '',
      isActive: true,
      dateOfRegistration: new Date(),
      ip: '192.168.50.55',
      serial: '',
      model: 'DS-K1T320MFWX',
      attendanceType: this.EmpAttendanceTypeDefault,
      port: '80',
      CVs: this.EmpAttendanceDeviceCVsDefault,
      deviceType: this.fingerPrintDeviceTypeDefault,
      branchId: this.DefaultBranch,
      day: null,
      month: null,
      year: null,
      seconed: null,
      minute: null,
      hour: null,
      enrollid: null,
      inout: null,
      machinenum: null
    };
    console.log('🔄 Form reset');
  }
}